import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import optainLogoImg from 'src/assets/icons/logo-b/optain.png';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

interface LoginContainerProps {
  children: React.ReactNode;
}

const LoginContainer = ({ children }: LoginContainerProps) => {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModal show centered scrollable={false} className="bg-solid">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <img
            src={optainLogoImg}
            alt="Logo"
            width={50}
            className="object-fit-contain"
          />
          <span className="ms-2">{t('loginLogout.title')}</span>
        </Modal.Title>
      </Modal.Header>
      {children}
    </CustomModal>
  );
};

export default LoginContainer;
